import React, { useState } from "react";
import {
  Box,
  Container,
  FormControl,
  Stepper,
  Step,
  StepLabel,
  Button,
  Typography,
  Stack
} from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";
import { Formik, Form } from "formik";
import { useSelector, useDispatch } from "react-redux";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { uploadFormPostdoc } from "../../core/service/uploadForm.service";

import UploadFormInfo from "./Forms/UploadFormInfo";
import UploadFormPage1 from "./Forms/UploadFormPage1";
import UploadFormPage2SecA from "./Forms/UploadFormPage2SecA";
import UploadFormPage2SecB from "./Forms/UploadFormPage2SecB";
import UploadFormPage2SecC from "./Forms/UploadFormPage2SecC";
import UploadFormPage2SecD from "./Forms/UploadFormPage2SecD";

import Page404 from "../Page404";

import validationSchema from "./FormModel/validationSchema";
import PostDocUploadFormModel from "./FormModel/PostDocUploadFormModel";
import formInitialValues from "./FormModel/formInitialValues";

let steps = ["Page Info", "Page 1", "Page 2"];
const FORM_SEC_A = "section_a";
const FORM_SEC_B = "section_b";
const FORM_SEC_C = "section_c";
const FORM_SEC_D = "section_d";
const { formId, formField } = PostDocUploadFormModel;

function _renderStepContent(step, checkFormPage) {
  switch (step) {
    case 0:
      return <UploadFormInfo formField={formField} />;
    case 1:
      return <UploadFormPage1 formField={formField} />;
    case 2:
      return checkFormPage === FORM_SEC_A ? (
        <UploadFormPage2SecA formField={formField} />
      ) : checkFormPage === FORM_SEC_B ? (
        <UploadFormPage2SecB formField={formField} />
      ) : checkFormPage === FORM_SEC_C ? (
        <UploadFormPage2SecC formField={formField} />
      ) : (
        checkFormPage === FORM_SEC_D && (
          <UploadFormPage2SecD formField={formField} />
        )
      );
    default:
      return <Page404 />;
  }
}

export default function UploadFormPostDoc() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { user: currentUser, role } = useSelector((state) => state.authReducer);
  const { pagePostDoc } = useSelector((state) => state.uploadFormReducer);

  const [activeStep, setActiveStep] = useState(0);
  // const currentValidationSchema = validationSchema[activeStep];
  const currentValidationSchema = validationSchema(pagePostDoc, activeStep);
  const isLastStep = activeStep === steps.length - 1;

  function _sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  async function _submitForm(values, actions) {
    var formData = new FormData();

    await _sleep(1000);
    actions.setSubmitting(false);

    for (const [key, value] of Object.entries(values)) {
      if (value?.file) {
        formData.append(key, value.file);
      } else {
        formData.append(key, value);
      }
    }
    formData.append("user_id", currentUser.id);

    await uploadFormPostdoc(formData);
    // setActiveStep(activeStep + 1);
  }

  const successSubmit = () => {
    Swal.fire({
      icon: "success",
      title: "Successfully",
      showConfirmButton: false,
      timer: 1500
    }).then((result) =>
      navigate(`/research-progress/${role}`, { replace: true })
    );
  };

  async function _handleSubmit(values, actions) {
    if (isLastStep) {
      await _submitForm(values, actions);
      successSubmit();
    } else {
      setActiveStep(activeStep + 1);
      actions.setTouched({});
      actions.setSubmitting(false);
    }
  }

  function _handleBack() {
    setActiveStep(activeStep - 1);
  }

  return (
    <Container>
      <Box>
        <>
          <Typography component="h1" variant="h4">
            Progress Report/Final Report Form for Postdoctoral Fellowship
          </Typography>
          <FormControl>
            <Stepper activeStep={activeStep} sx={{ paddingTop: 6 }}>
              {steps.map((label) => (
                <Step key={label}>
                  <StepLabel>{label}</StepLabel>
                </Step>
              ))}
            </Stepper>
          </FormControl>

          {/* {activeStep === steps.length ? (
            successSubmit()
          ) : ( */}
          <Formik
            initialValues={formInitialValues}
            validationSchema={currentValidationSchema}
            onSubmit={_handleSubmit}
          >
            {({ isSubmitting, getFieldMeta }) => {
              const infoCheck = getFieldMeta("statementReportGuideline");

              return (
                <Form id={formId}>
                  <Box sx={{ paddingTop: 6, paddingBottom: 6 }}>
                    {_renderStepContent(activeStep, pagePostDoc)}
                  </Box>

                  <Stack
                    direction="row"
                    justifyContent="space-evenly"
                    alignItems="center"
                    spacing={12}
                    sx={{ paddingTop: 3 }}
                  >
                    {activeStep !== 0 && (
                      <Button
                        size="large"
                        variant="contained"
                        onClick={_handleBack}
                      >
                        Back
                      </Button>
                    )}
                    {activeStep === 0 && (
                      <Button
                        size="large"
                        variant="contained"
                        onClick={()=>{
                          navigate(`/research-progress/post_doc`, { replace: true })
                        }}
                        // href="/research-progress/post_doc"
                      >
                        Cancel
                      </Button>
                    )}
                    <LoadingButton
                      loading={isSubmitting}
                      size="large"
                      disabled={isSubmitting || infoCheck.value === "no"}
                      type="submit"
                      variant="contained"
                      color="primary"
                    >
                      {isLastStep ? "Submit" : "Next"}
                    </LoadingButton>
                  </Stack>
                </Form>
              );
            }}
          </Formik>
          {/* )} */}
        </>
      </Box>
    </Container>
  );
}
